'use client';

import { classNames } from '@bytel/product-wall/helpers';
import { Box, BoxContent, Spacer, SpacerSize, Sticker, Text, TextLevels, TypographyBold } from '@bytel/trilogy-react';

import { HomepackProduct, HomepackProductOptions, StaticPackProduct } from '@app-types/home-pack';

interface ProductSizeContainerProps {
    product: HomepackProduct;
    detail: HomepackProductOptions;
    selectedProduct?: StaticPackProduct;
    onSelectedProduct: (mainProduct: HomepackProduct, details: HomepackProductOptions) => void;
}

export function ProductSizeContainer({
    product,
    detail,
    selectedProduct,
    onSelectedProduct,
}: Readonly<ProductSizeContainerProps>) {
    const isActive = selectedProduct?.mainProduct?.id === product.id && selectedProduct?.details?.cm === detail.cm;

    return (
        <Box
            fullheight
            className='is-flex is-vertical is-centered'
            active={isActive}
            onClick={() => {
                if (product) {
                    onSelectedProduct(product, detail);
                }
            }}
            flat
        >
            <BoxContent className='is-flex is-vertical is-centered has-text-centered is-aligned-center'>
                {detail?.promo && (
                    <Sticker
                        small
                        className={classNames(
                            'is-absolute product-promo-sticker',
                            isActive ? 'is-secondary' : 'has-background-grey-fade',
                        )}
                        label='Bon plan'
                    />
                )}
                <Spacer size={SpacerSize.TWO} />
                <Text marginless typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>{`${detail.pouces}"`}</Text>
                <Text marginless level={TextLevels.THREE}>{`${detail.cm} cm`}</Text>
                <Spacer size={SpacerSize.TWO} />
            </BoxContent>
        </Box>
    );
}
